
export const environment = {
    envName: 'dev',
    production: false,
    hostname: 'dev.uniontracker.toyota.com',
    apiBaseUrl: 'https://dev.uniontracker.toyota.com',
    logger: {
      level: 'DEBUG'
    },
    xApiKey: '',
    TENANT_ID: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef',
    CLIENT_ID: '21bbd591-6a5e-435f-acba-0e8be4ebfdbb',
    REDIRECT_URL: 'https://dev.uniontracker.toyota.com',
    apiUrl: {
        lookupUrl: 'https://api.dev.uniontracker.toyota.com/lookup/',
        suppliermanagUrl: 'https://api.dev.uniontracker.toyota.com/management/'
    }
  };
  